import React, {FC} from "react"

import zipImageForPayments from "@irati-web/payments/src/images/zip_logo.svg"
import zipDetailsForPayments from "@irati-web/payments/src/images/zip-circle-alert.svg"
import {FormattedMessage} from "@irati/utils/lang"
import Flex from "@irati/ui/src/Flex"
import {Label} from "@irati/ui/src/Typography"
import ZipReadMoreAndModal from "@irati-web/payments/src/components/ZipModal/ZipReadMoreAndModal"
import {PaymentProvider} from "@irati/types"
import {Radio, CustomNodeRenderer} from "@irati/ui/src/FormItem"
import withBasket, {WithBasket} from "@irati/checkout/utils/basket/withBasket"

import {ZipImage, ZipDetail, HeaderWrapper} from "./styled"

interface Props extends WithBasket {
  isZipSelected: boolean,
  onSelectZip: (value: PaymentProvider) => any
}

const PayByZip: FC<Props> = (props: Props) => {
  const {isZipSelected, onSelectZip} = props

  const discountBeforeZip = props.basket.breakdown.total.discountPercentage
  const discountAfterZip = props.basket.breakdown.total.discountPercentageAfterServiceCharge

  const zipOptions = [
    {
      customNode: (
        <Flex direction="column">
          <Flex justifyContent="space-between" alignItems="center">
            <ZipImage src={zipImageForPayments} />
            <ZipReadMoreAndModal />
          </Flex>
        </Flex>
      ),
      value: PaymentProvider.Zip,
      whiteSpace: "wrap"
    }
  ]

  return (
    <HeaderWrapper selected={isZipSelected}>
      <Radio
        rowRenderer={CustomNodeRenderer}
        name="paymentMethodRadio"
        value={isZipSelected && PaymentProvider.Zip}
        options={zipOptions}
        onChange={() => onSelectZip(PaymentProvider.Zip)} />

      {isZipSelected && (
        <Flex alignItems="center" marginTop={1} paddingBottom={1} marginLeft="48px">
          <ZipDetail src={zipDetailsForPayments} />
          <Label>
            <FormattedMessage
              id="platform.wallet.components.payByWallet.zip.details"
              values={{
                discountBeforeZip,
                discountAfterZip
              }} />
          </Label>
        </Flex>
      )}
    </HeaderWrapper>
  )
}

export default withBasket(PayByZip)
